import React from "react";
import "./contactUs.css";
import { Phone, Mail, MapPin } from "lucide-react";
import { Helmet } from "react-helmet";

export default function ContactUs() {
  return (
    <>
<Helmet>
  <script type="application/ld+json">
{`
{
  "@context": "https://schema.org",
  "@type": "ContactPage",
  "name": "Contact AutoCare Car Repair",
  "description": "Get in touch with AutoCare for expert car repair and servicing in Palwal.",
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+91 9467214453",
    "email": "support@autocarepalwal.com",
    "contactType": "Customer Service"
  }
}
`}
</script>
  <title>
    Contact AutoCare | Best Car Repair & Auto Mechanic in Palwal
  </title>

  <meta
    name="description"
    content="Contact AutoCare, the trusted car repair and auto mechanic service in Palwal. Call or book a service for professional car servicing, repairs, and detailing."
  />

  <link
    rel="canonical"
    href="https://car-repair-mechanic-palwal.netlify.app/contact"
  />

  {/* Open Graph */}
  <meta property="og:title" content="Contact AutoCare – Car Repair in Palwal" />
  <meta
    property="og:description"
    content="Get in touch with AutoCare for expert car repair and servicing in Palwal."
  />
</Helmet>

    <section className="contactPage">
      <div className="contactWrapper">

        {/* LEFT INFO */}
        <div className="contactInfo">
          <h1>Contact AutoCare – Best Car Repair in Palwal</h1>
          <p>
            Looking for a <span className="highlight">trusted car repair shop in Palwal</span>?
            AutoCare offers professional auto repair, servicing, and detailing with
            expert technicians and modern equipment.
          </p>

          <div className="infoBox">
            <div className="infoItem">
              <Phone />
              <span>+91 9467214453</span>
            </div>
            <div className="infoItem">
              <Mail />
              <span>support@autocarepalwal.com</span>
            </div>
            <div className="infoItem">
              <MapPin />
              <span>AutoCare, Palwal, Haryana</span>
            </div>
          </div>

          <div className="trustBadges">
            <span>✔ 1000+ Happy Customers</span>
            <span>✔ Certified Mechanics</span>
            <span>✔ Best Auto Care in Palwal</span>
          </div>
        </div>

        {/* RIGHT FORM */}
        <div className="contactForm">
          <h2>Book Your Service</h2>

          <form>
            <div className="inputGroup">
              <input type="text" required />
              <label>Full Name</label>
            </div>

            <div className="inputGroup">
              <input type="tel" required />
              <label>Phone Number</label>
            </div>

            <div className="inputGroup">
              <input type="email" required />
              <label>Email Address</label>
            </div>

            <div className="inputGroup">
              <select required>
                <option value=""></option>
                <option>Periodic Maintenance</option>
                <option>Brake Repair</option>
                <option>Suspension Repair</option>
                <option>Car Detailing</option>
                <option>Accidental Repair</option>
              </select>
              <label>Select Service</label>
            </div>

            <div className="inputGroup">
              <textarea rows="4" required></textarea>
              <label>Your Message</label>
            </div>

            <button type="submit" className="submitBtn">
              Get Call Back
            </button>
          </form>
        </div>

      </div>
    </section>
    </>
  );
}
